import React, {
  useState,
  useContext,
  useEffect,
}                           from 'react';
import { historyPropType }  from '~/config/routerPropTypes';
import { showPush }         from '~/config/routes';
import Request              from '~/providers/Request';
import Push                 from './context';
import PushRecord           from '~/records/PushRecord';
import Form                 from './Form';

function EditRecord({history}){
  const [ record, setRecord] = useState(new PushRecord());
  const [ loading, setLoading] = useState(false);
  const { records, addRecords } = useContext(Push);
  const { id } = history.location.route.getParams();
  
  useEffect(() => {
    async function fetchData(id){
      if(records && records[id]){
        record.updateAttributes(records[id]);
      }

      setLoading(true);
      Request.get(`/admin/push_messages/${id}`, {})
        .then( response => {
          setLoading(false);
          addRecords({ data: [response.data] }); //Array para reusar o util de transformar e jogar no contexto.
          setRecord( record.updateAttributes(response.data) );
        })
        .catch( e => {
          console.error(e);
          setLoading(false);
        });
    }
    fetchData(id);
  }, []);

  const handleChange = (attrs) => {
    setRecord( record.updateAttributes(attrs) );
  };

  async function onSubmit (){

    let image_id = record.get('image_id') ? record.get('image_id') : null;
    const imageBase64 = record.get('image_base64');
    setLoading(true);
    if(imageBase64){
      try {
        const result = await Request.post('/upload_base64', { file: `data:image/jpg;base64,${imageBase64}` });
        image_id = result.data.id;
      } catch(e) {console.log(e);}
    }

    const data = record.toParams({image_id});
    Request.put(`/admin/push_messages/${id}`, data, {}, { controller: 'push' })
      .then((resp) => {
        setLoading(false);
        history.push(showPush.reverse(resp.data));
      })
      .catch(e => {
        console.error(e);
        setLoading(false);
      });
  }

  return(
    <Form
      onSubmit={onSubmit}
      record={record}
      handleChange={handleChange}
      loading={loading}
      setRecord={setRecord}
    />
  );
}

EditRecord.propTypes={
  history: historyPropType,
};

export default EditRecord;
